import React from "react";
import { MapPin, Phone } from "lucide-react";
import { BAR, MAPS_CID_URL } from "@/lib/info";

const MobileBottomBar = () => {
  return (
    <>
      {/* Spacer so content isn't covered on mobile */}
      <div className="md:hidden h-14" aria-hidden="true" />

      <div
        data-testid="mobile-bottom-bar"
        className="md:hidden fixed bottom-0 left-0 right-0 h-14 bg-[#161616]/95 border-t border-[#333] backdrop-blur-md flex z-[70]"
        style={{ boxShadow: "0 -5px 20px rgba(0, 0, 0, 0.6)" }}
      >
        <a
          href={MAPS_CID_URL}
          target="_blank"
          rel="noreferrer"
          data-testid="mobile-cta-directions"
          className="flex-1 flex items-center justify-center gap-2 text-xs font-mono-plex font-bold uppercase tracking-[0.18em] text-black bg-[#FFB800] hover:bg-[#ffc43d] active:bg-[#e6a100] transition-colors border-r border-[#1A1A1A]"
        >
          <MapPin size={14} strokeWidth={2.5} />
          Get Directions
        </a>
        <a
          href={`tel:${BAR.phone.tel}`}
          data-testid="mobile-cta-call"
          className="flex-1 flex items-center justify-center gap-2 text-xs font-mono-plex font-bold uppercase tracking-[0.18em] text-white bg-[#222] hover:bg-[#2A2A2A] active:bg-[#1A1A1A] transition-colors"
        >
          <Phone
            size={14}
            strokeWidth={2.5}
            className="text-[#FF2A2A]"
          />
          Call Us Now
        </a>
      </div>
    </>
  );
};

export default MobileBottomBar;
